// FORMAT OPTIONS
export const NUM_DECIMALS = 2;
export const USE_CAPITALS = true;
export const USE_SPACES = true;
export const SECONDS_IN_A_DAY = 86400;
